{
  "srTitle": "Anti Human Safari Project — drone protection for civilians in Kherson, Ukraine",
  "logoAlt": "Anti Human Safari Project logo",
  "intro": "We provide protective equipment against small drone attacks to volunteers, emergency services and critical infrastructure workers in Kherson, Ukraine.",
  "safari": "Since summer 2024 civilians in Kherson are systematically hunted by the Russian army using video drones, in a terror campaign known as \"Human Safari\".",
  "unLink": "UN Commission Recognises Human Safari as a War Crime",
  "donateNow": "Donate Now",
  "donateMonthly": "Donate Monthly",
  "otherWays": "other ways to donate",
  "instagram": "Instagram",
  "pastFundraisers": "Past fundraisers:",
  "fundraiser2025": "Fundraiser 2025",
  "donateVia": "Donate via:",
  "charityRef": "via UK Charity, with reference:",
  "germanCharityRef": "via German Charity, with reference:",
  "copy": "Copy",
  "copied": "Copied!",
  "close": "Close",
  "viewMedia": "View media",
  "andrushenkoCredit": "Oleksandr Andrushenko, photo correspondent for the outlet Vgoru",
  "fruitSellerDescription": "Fruit seller chased by fibre-optic drone",
  "khersonPoliceCredit": "from @khersonpolice",
  "firefighterDescription": "Firefighter extinguishes a car after a Human Safari strike, victim lies behind",
  "previousMedia": "Previous",
  "nextMedia": "Next",
  "fpvDroneDescription": "FPV drone out on Human Safari",
  "busAttackDescription": "One of many FPV drone attacks on public transport",
  "notFoundTitle": "Page not found",
  "notFoundMessage": "That page does not exist. It may have been moved or the link may be wrong.",
  "backHome": "Back to home",
  "droneDetectorDescription": "Drone detectors are small handheld devices which can warn if a drone is near",
  "vestDescription": "Lightweight protective vests can reduce the severity of injuries from a drone attack"
}
